module.exports = __webpack_public_path__ + "img/radio.ee046b4d.gif";